// Settings sections: a rail of tabs with one pane visible at a time, so adding
// a section is one rail row instead of more scrolling in a single long panel.
import { loadSettingsPane, saveSettingsPane } from './preferences';
import { dom } from './ui';

export function initSettingsTabs(): void {
  const tabs = Array.from(dom.settingsPanel.querySelectorAll<HTMLButtonElement>('.settings-tab'));
  const panes = Array.from(dom.settingsPanel.querySelectorAll<HTMLElement>('.settings-pane'));
  const body = dom.settingsPanel.querySelector<HTMLElement>('.settings-body');

  function select(tab: HTMLButtonElement, remember = true): void {
    const paneId = tab.dataset.pane;
    if (!paneId) return;
    if (remember) saveSettingsPane(paneId);

    for (const other of tabs) {
      const on = other === tab;
      other.classList.toggle('active', on);
      other.setAttribute('aria-selected', on ? 'true' : 'false');
      // Roving tabindex: Tab reaches the rail once, arrows move within it.
      other.tabIndex = on ? 0 : -1;
    }
    for (const pane of panes) pane.classList.toggle('hidden', pane.id !== paneId);

    dom.settingsPaneTitle.textContent = tab.querySelector('span')?.textContent ?? '';
    if (body) body.scrollTop = 0;
  }

  // The rail used to open on Display every time, whichever section you were
  // working in. Restore silently: reopening is not a choice worth re-saving.
  const storedPane = loadSettingsPane();
  const stored = storedPane ? tabs.find(t => t.dataset.pane === storedPane) : undefined;
  if (stored) select(stored, false);

  tabs.forEach((tab, index) => {
    tab.tabIndex = tab.classList.contains('active') ? 0 : -1;
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', e => {
      const forward = e.key === 'ArrowDown' || e.key === 'ArrowRight';
      const back = e.key === 'ArrowUp' || e.key === 'ArrowLeft';
      if (!forward && !back) return;
      e.preventDefault();
      const next = tabs[(index + (forward ? 1 : -1) + tabs.length) % tabs.length];
      select(next);
      next.focus();
    });
  });
}
